import component from "./MissingUSAWKFIDReport.js";

export default component;
